import { Directive, ElementRef, Output, EventEmitter, HostListener, Input } from '@angular/core';


/**
 * @description
 * Rc click outside directive - emit a callback function once the user click outside the element
 *
 * @example
 * <div lib-rc-click-outside (clickOutside)="myFunc()">Some content</div>
 *
 */
@Directive({
  selector: '[lib-rc-click-outside]'
})
export class RcClickOutsideDirective {
  constructor(private _elementRef: ElementRef) {
  }
  @Output() clickOutside = new EventEmitter();

  @HostListener('document:touchend', ['$event.target'])
  @HostListener('document:click', ['$event.target'])
  public onClick(targetElement, ) {
    const clickedInside = this._elementRef.nativeElement.contains(targetElement);
    if (!clickedInside) {
      this.clickOutside.emit();
    }
  }
}
